import React from "react";
import Container from "react-bootstrap/Container";

import MetaTitle from "./MetaTitle";
import Title from "./Title";
import Text from "./Text";
import CarouselCards from "./CarouselCards";

export default function LiveAndOnlineEvents({ data, additionalData }) {
	const hashLink = "liveAndOnlineEvents";
	
	// Get events data from data.fields.jsonData.data
	// The data prop contains {sys: {...}, fields: {...}} structure

	const eventsData = data?.fields?.jsonData?.data || [];
	const sectionConfig = data?.fields?.jsonData?.sectionConfig || {};

	const config = {
		metaTitle: sectionConfig.metaTitle || "Live and Online Events",
		title: sectionConfig.title || "Participate",
		description: sectionConfig.description || "Forge meaningful connections that uncover new opportunities and provide actionable feedback.",
		...sectionConfig
	};
	
	// Fallback to empty array if no data is found
	if (!eventsData || !Array.isArray(eventsData)) {
		console.warn("LiveAndOnlineEvents: No events data found or invalid format");
		return null;
	}

	return (
		<section id={hashLink} className="live-online-events-section">
			<div className="inner-wrapper">
				<Container fluid className="px-4 px-md-5">
					{/* Header Section */}
					<div className="header-section text-start mb-2">
						<MetaTitle textAlign="start" text={config.metaTitle} />
						<Title
							className="w-100"
							textJustify="start"
							textAlign="start"
							element="h2"
							text={config.title}
							marginBottom={1}
						/>
						<Text
							text={config.description}
							textAlign="start"
							size="16"
							weight="100"
							textJustify="start"
							className="mb-0 text-muted"
						/>
					</div>

					<CarouselCards 
						items={eventsData}
						hasImages={false}
						backgroundColor="#f8f9fa"
					/>
				</Container>
			</div>

			<style jsx="true">{`
				.live-online-events-section {
					background: #f8f9fa;
					padding: 1.5rem 0;
					position: relative;
					margin-bottom: 4rem;
				}

				.inner-wrapper {
					background: #f8f9fa;
				}

				.header-section {
					margin-bottom: 2rem;
					position: relative;
				}

				/* Override CarouselCards spacing */
				.live-online-events-section :global(.carousel-slide) {
					padding: 0 8px;
				}

				.live-online-events-section :global(.card.no-image) {
					min-height: 250px;
				}

				.live-online-events-section :global(.card-content) {
					padding: 1rem 1rem 1.5rem;
				}

				.live-online-events-section :global(.carousel-nav-container) {
					top: -60px;
				}

				/* Responsive Design */
				@media (max-width: 768px) {
					.header-section {
						margin-bottom: 1.5rem;
					}
					
					.live-online-events-section {
						padding: 1rem 0;
					}

					.live-online-events-section :global(.card.no-image) {
						min-height: 220px;
					}

					.live-online-events-section :global(.card-content) {
						padding: 1rem 1rem 1.2rem;
					}
				}
			`}</style>
		</section>
	);
}